<!-- Variant 0: minimal -->
@if (variant === 'minimal') {
  <wl-basic-content-variant-minimal
    [content]="content"
    [settings]="settings"
    [context]="context"
    [cardConfig]="cardConfig"
  >
  </wl-basic-content-variant-minimal>
}

<!-- Variant 1: (sub)title + text | <ng-content> | buttons + microcopy -->
@if (variant === 'ngContentBetween') {
  <wl-basic-content-variant-ng-content-between [content]="content">
    <ng-content></ng-content>
  </wl-basic-content-variant-ng-content-between>
}

<!-- Variant 2: Vertical-Icon -->
@if (variant === 'vertical-icon') {
  <wl-basic-content-variant-vertical-icon
    [content]="content"
    [settings]="settings"
    [context]="context"
    [cardConfig]="cardConfig"
  ></wl-basic-content-variant-vertical-icon>
}

<!-- Variant 3: Vertical Image -->
@if (variant === 'vertical-image') {
  <wl-basic-content-variant-vertical-image
    [content]="content"
    [settings]="settings"
    [context]="context"
    [image]="image"
    [cardConfig]="cardConfig"
  ></wl-basic-content-variant-vertical-image>
}

<!-- Variant 4: Placeholder -->
@if (variant === 'placeholder') {
  <wl-basic-content-variant-placeholder
    [content]="content"
    [settings]="settings"
    [context]="context"
    [rendering]="rendering"
    [cardConfig]="cardConfig"
  ></wl-basic-content-variant-placeholder>
}
